import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-secondary-section',
  templateUrl: './secondary-section.component.html',
  styleUrls: ['./secondary-section.component.scss']
})
export class SecondarySectionComponent implements OnInit, OnChanges {
  listOfSecondarySections: any;
  sectionSuggestion1: any;
  subsectionSuggestion: any =[];
  allSubSections: any;
  sectionName: any;
  subSectionName:any;
  secondarySectionSuggestion: any = [];

  @Input()
  set secondarySectionData (listOfSecondarySections: any) {
    this.listOfSecondarySections = listOfSecondarySections ? listOfSecondarySections : [];
  }

  @Input()
  set listOfAllSubsections (subsectionList: any) {
    this.allSubSections = subsectionList ? subsectionList : [];
  }

  @Input() sectionSuggestionList: any;

  @Input() subsectionSuggestionList:any;
  
  @Input()
  set section (section: any) {
    this.sectionName = section ? section : [];
  }

  @Input()
  set subSection(subSection:any){
    this.subSectionName = subSection?subSection:[];
  }
  @Input() storyEditMode : boolean;

  @Output() secondarySectionChanged: EventEmitter<number> = new EventEmitter();

  constructor() { }
  ngOnChanges(changes: SimpleChanges){
    this.sectionSuggestion1 = this.sectionSuggestionList;
    this.subsectionSuggestion = this.subsectionSuggestionList;
    this.prepareSecondarySectionsList();
  }

  ngOnInit() {
    this.prepareSecondarySectionsList();
  }
  prepareSecondarySectionsList() {
    this.secondarySectionSuggestion = this.sectionSuggestion1;
    if(this.secondarySectionSuggestion.indexOf(this.sectionName) > -1){ 
      this.subsectionSuggestion[this.sectionName] = this.subsectionSuggestion[this.sectionName].filter(subsec=> subsec!==this.subSectionName);
    }
    for(const i in this.listOfSecondarySections) {
      if(this.secondarySectionSuggestion.indexOf(this.listOfSecondarySections[i]['section']) > -1){
        this.subsectionSuggestion[this.listOfSecondarySections[i]['section']] = 
          this.subsectionSuggestion[this.listOfSecondarySections[i]['section']]
            .filter(subsec => subsec !==this.listOfSecondarySections[i]['subSection']);
        }
    }
  }

  addNewSection() {
    this.listOfSecondarySections.push(
      {
        "section":"",
        "subSection":""
      }
    )
    this.prepareSecondarySectionsList();
  }
  deleteSection(addedSection: any) {
    // add back to list while deleting
    if(this.secondarySectionSuggestion.indexOf(addedSection['subSection']) === -1 && addedSection['subSection'] !== ""){
      this.subsectionSuggestion[addedSection['section']].push(addedSection['subSection']);
    }
    this.listOfSecondarySections.splice(this.listOfSecondarySections.indexOf(addedSection),1)
  }


  sectionChangedHandler(ev)
  {
    this.prepareSecondarySectionsList();
    this.secondarySectionChanged.emit(ev)
  }

}
